import LocationFilter from './LocationFilter';
export default LocationFilter;
